import React, { useState } from 'react';
import DynamicIcon from './dynamic-icon';

const PrimarySearch = ({ placeholder, onSearch, additionalclasses, disabled,onFocus }) => {
    const [searchValue, setSearchValue] = useState('');

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        {onSearch && onSearch(value);}
    };

    return (
        <div className={`w-full h-[40px] rounded-[10px] custom-bg-white-200 px-[12px] flex items-center gap-[12px] text-[14px] poppins-regular leading-[21px] placeholder-grey-200 dark:placeholder-grey-dark-200 custom-text-grey-900 ${additionalclasses}`}>
            <DynamicIcon name='search' size={18} />
            <input 
                type="text" 
                placeholder={placeholder} 
                className='w-full outline-none bg-[transparent]'
                value={searchValue}
                onChange={handleChange}
                disabled={disabled}
                onFocus={onFocus}
            />
            {/* <DynamicIcon name='list-filter' size={18} /> */}
        </div>
    );
};

export default PrimarySearch;